import React from 'react';
import { useTranslation } from 'react-i18next';
import unnamedLightLogo from '../../../assets/images/unnamed-light-logo.png';
import beianIcon from '../../../assets/images/beian.png';
import './HomeFooter.scss';

const FOOTER_LINKS = [
  { key: 'home.footer.about', href: '#about' },
  { key: 'home.footer.products', href: '#products' },
  { key: 'home.footer.philosophy', href: '#philosophy' },
  { key: 'home.footer.contact', href: '#contact' },
];

function HomeFooter() {
  const { t, i18n } = useTranslation();
  const isEn = !i18n.language?.startsWith('zh');

  return (
    <footer id="contact" className={`home-footer ${isEn ? 'home-footer--en' : ''}`}>
      <div className="home-footer__inner">
        <div className="home-footer__brand">
          <img
            src={unnamedLightLogo}
            alt="Unnamed Light"
            className="home-footer__logo"
          />
          <h3 className="home-footer__name">{t('home.footer.brand')}</h3>
          <p className="home-footer__tagline">{t('home.footer.tagline')}</p>
        </div>

        <nav className="home-footer__links">
          {FOOTER_LINKS.map((link) => (
            <a key={link.key} href={link.href} className="home-footer__link">
              {t(link.key)}
            </a>
          ))}
        </nav>

        <div className="home-footer__legal">
          <p className="home-footer__copyright">© 2025-{new Date().getFullYear()} {t('home.footer.copyright')}</p>
          <div className="home-footer__filing">
            <a
              className="home-footer__icp"
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
            >
              粤ICP备2025433423号-3
            </a>
            <a
              className="home-footer__gongan"
              href="https://beian.mps.gov.cn/#/query/webSearch?code=44010402003632"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={beianIcon} alt="公安备案" className="home-footer__gongan-icon" />
              粤公网安备44010402003632号
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default HomeFooter;
